import { CloseOutlined } from '@ant-design/icons'
import { Popup, Modal } from 'antd-mobile'
import React from 'react'
import general, { redux } from '../../general'
import Dialog from '../../lib/Dialog'

export default function CommunityAction({ visible, handleClose, item }) {

  let actions = []
  if (parseInt(item.recover) == 2) {
    actions = [
      { title: '删除', src: 'resources/251009/remove.png', type: 'delete' }
    ]
  } else {
        // if (item.tagid == 1) {
      actions = [
        { title: parseInt(item.is_user_top) == 1 ? '取消置顶' : '置顶', src: 'resources/251009/' + (parseInt(item.is_user_top) == 1 ? 'calcen_top' : 'pin_top') + '.png', type: 'top' },
        { title: '编辑', src: 'resources/250424/edit.png', type: 'edit' },
        { title: '删除', src: 'resources/251009/remove.png', type: 'delete' }
      ]
    // } else {
    //   actions = [
    //     { title: '删除', src: 'resources/251009/remove.png', type: 'delete' }
    //   ]
    // }
  }

  const handleDelete = () => {
    general.axios.post('/delCommunityData', {
      id: item.id,
      circles_type: item.circles_type,
      tagid: item.tagid,
      tab: parseInt(item.tagid) == 3 ? item.tab : ''
    }).then((res) => {
      const { status, data } = res.data
      if (status.succeed) {
        Modal.clear()
        redux.dispatch({
          type: 'deleteCommunityItem',
          data: {
            deleteCommunityItemId: item.id
          }
        })
        setTimeout(() => {
          Dialog.info('删除成功')
        }, 300);
      } else {
        Dialog.info(status.error_desc)
      }
    })
  }

  const handleAction = (action) => {
    if (action.type == 'top') {
      Dialog.loading()
      general.axios.post('/activePinningTop', {
        circles_type: item.circles_type,
        is_user_top: parseInt(item.is_user_top) == 1 ? 0 : 1,
        tagid: item.tagid,
        id: item.id,
        tab: parseInt(item.tagid) == 3 ? item.tab : ''
      }).finally(() => {
        Dialog.close()
      }).then((res) => {
        const { status, data } = res.data
        if (status.succeed) {
          redux.dispatch({
            type: 'updateUserTopItem',
            data: {
              updateUserTopItemId: true
            }
          })
          handleClose()
          setTimeout(() => {
            Dialog.info(parseInt(item.is_user_top) == 1 ? '取消置顶成功' : '置顶成功')
          }, 300);
        } else {
          Dialog.info(status.error_desc)
        }
      })
    } else if (action.type == 'delete') {
      handleClose()
      Modal.show({
        title: '温馨提示',
        closeOnMaskClick: true,
        className: 'game-sign-title',
        content: (
          <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            <div style={{ fontSize: 12, color: '#666', padding: 5 }}>确认删除吗?</div>
            <div onClick={handleDelete} style={{ backgroundColor: 'var(--MainColor)', width: '183px', height: '44px', color: 'white', fontSize: '15px', textAlign: 'center', borderRadius: '22px', lineHeight: '44px', marginTop: '10px' }}>确认</div>
            <div onClick={() => {
              Modal.clear()
            }} style={{ fontSize: '13px', color: '#999', paddingTop: '10px' }}>取消</div>
          </div>
        ),
      })
    } else if (action.type == 'edit') {
      handleClose()
      general.history.push('/publish?tagid=' + item.tagid + '&topic_id=' + item.maiyou_gameid + '&circles_type=' + item.circles_type + "&id=" + (parseInt(item.recover) == 2 ? item.community_id : item.id) + "&isEdit=1")
    }
  }

  return (
    <div>
      <Popup
        className='publish-alert-wrapper'
        getContainer={document.getElementById('root')}
        visible={visible}
        bodyStyle={{ borderTopLeftRadius: '13px', borderTopRightRadius: '13px' }}
      >
        <div style={{ paddingTop: 50, paddingBottom: 30, position: 'relative' }}>
          <div style={{ position: 'absolute', top: 0, right: 0, padding: 20 }} onClick={() => {
            handleClose()
          }}>
            <CloseOutlined style={{ color: '#999' }}></CloseOutlined>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {actions.map((action, index) => (
              <div key={index} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '20%' }} onClick={() => handleAction(action)}>
                <div style={{ backgroundColor: '#F5F5F5', borderRadius: '50%', width: 50, height: 50, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={action.src} alt="" height={22} />
                </div>
                <div style={{ fontSize: 12, color: '#666', paddingTop: 10 }}>{action.title}</div>
              </div>
            ))}
          </div>
        </div>
      </Popup>
    </div>
  )
}
